// global
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
// local
// api
import * as Patient from 'app/api/patient';
// actions
import dispatchError from './error';
import { pending, rejected, fulfilled } from './async';

const TEMPLATE_NAME = 'PATIENT_DETAIL';

export const detail = id => {
    return dispatch => {
        dispatch(pending(TEMPLATE_NAME));
        Patient.detail(id)
            .then(payload => dispatch(fulfilled(TEMPLATE_NAME, payload)))
            .catch(err => {
                dispatch(rejected(TEMPLATE_NAME, err));
                dispatchError(dispatch, err);
            });
    };
};

export function back() {
    return goBack();
}

export function openMap() {
    return push(`/`);
}
